import React from "react";
import { STORIES } from "../site-data";
import { Flower2 } from "lucide-react";

const ROSE_COLORS = [
  "#d6455b", "#e8b04e", "#e8a7b5", "#f1e3c4",
  "#c77bd0", "#e0b3e8", "#f08a5d", "#8ab7e0",
];

export default function Stories() {
  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="py-24 lg:py-36 bg-[#f0eae1]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="eyebrow mb-5">Eight Stories</p>
          <h2
            className="font-serif text-4xl lg:text-5xl leading-tight tracking-tight text-[#1c1a1a]"
            data-testid="stories-title"
          >
            Each rose, a <span className="italic text-[#8b2e3e]">small universe</span>.
          </h2>
          <p className="mt-5 text-[#4a4646] text-lg leading-relaxed">
            Tender glimpses into everyday lives where honesty, courage, and compassion
            quietly change the weather of a day.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {STORIES.map((s, idx) => {
            const span = idx === 0 || idx === 5 ? "lg:col-span-2 lg:row-span-1" : "";
            const colour = ROSE_COLORS[idx % ROSE_COLORS.length];
            return (
              <article
                key={s.title}
                data-testid={`story-card-${idx}`}
                className={`group relative bg-white border border-[#e5dcd0] p-7 lg:p-8 hover:border-[#8b2e3e] transition-colors duration-500 ${span}`}
              >
                <div className="flex items-start justify-between">
                  <div
                    className="h-10 w-10 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: `${colour}22`, color: colour }}
                    aria-hidden
                  >
                    <Flower2 size={18} strokeWidth={1.5} />
                  </div>
                  <span className="font-serif text-3xl text-[#e5dcd0] group-hover:text-[#8b2e3e] transition-colors">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>

                <h3
                  className="mt-8 font-serif text-2xl leading-snug text-[#1c1a1a] group-hover:text-[#8b2e3e] transition-colors"
                  data-testid={`story-title-${idx}`}
                >
                  {s.title}
                </h3>
                <p className="mt-3 text-[#4a4646] leading-relaxed text-[15px]">
                  {s.blurb}
                </p>
                <p className="mt-6 eyebrow !text-[#4a4646]">
                  <span className="hairline !bg-[#4a4646] mr-3 align-middle opacity-60" />
                  {s.tone}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
